import { Component, ElementRef } from '@angular/core';
import {
  DesignAttributeType
} from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from '../../base/base-designer-component';

@Component({
  selector: 'sx-attributelist-designer',
  templateUrl: './attributeListDesigner.component.html'
})
export class SxAttributeList extends BaseDesignerComponent {

  constructor(container: ElementRef) {
    super(container, 'SxAttributeList');
  }

  loadDefaults(): void {
    super.loadDefaults();

    this.controlContext.linkValue = '';
    this.controlContext.label = '';
    this.controlContext.validationGroup= '';
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['LinkValue'] = this.controlContext.linkValue;
    info['label'] = this.controlContext.label;
    info['validationGroup']= this.controlContext.validationGroup;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const label = new DesignAttributeType(this.controlContext, 'string', 'linkValue', 'RULE_VALUE');
    const linkValue = new DesignAttributeType(this.controlContext, 'string', 'linkValue', 'RULE_VALUE');
    const validationGroupAtt = new DesignAttributeType(this.controlContext, 'string', 'validationGroup', 'VALIDATION_GROUP');

    this.attributes.push(label);
    this.attributes.push(linkValue);
    this.attributes.push(validationGroupAtt);
  }

  // here, we define the sub Form
  onDemoClick(){
    return; 
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/attributeListDesigner.component.ts